import { createSlice } from "@reduxjs/toolkit";
import { logoutUser } from "../actions/account";
import { generateContent, getGeneratedContent, stopGeneration, generateTagSummary, getGeneratedTagSummary, stopTagSummaryGeneration } from "../actions/ai";

const initialState = {
    error: false,
    isLoadingGenerateContent: false,
    isLoadingGetGeneratedContent: false,
    generatedContent: {},
    isLoadingGenerateTagSummary: false,
    isLoadingGetGeneratedTagSummary: false,
    tagSummary: {}
};

const aiSlice = createSlice({
    name: "ai",
    initialState,
    extraReducers: {
        [generateContent.pending]: (state, action) => {
            state.isLoadingGenerateContent = true;
            state.error = false;
        },
        [generateContent.fulfilled]: (state, action) => {
            state.isLoadingGenerateContent = false;
            state.generatedContent = { ...state.generatedContent, [`${action?.payload?.data?.moduleId}|${action?.payload?.data?.schemaKey}`]: action?.payload?.data };
            state.error = false;
        },
        [generateContent.rejected]: (state, action) => {
            state.isLoadingGenerateContent = false;
            state.error = true;
        },
        [getGeneratedContent.pending]: (state, action) => {
            state.isLoadingGetGeneratedContent = true;
            state.error = false;
        },
        [getGeneratedContent.fulfilled]: (state, action) => {
            state.isLoadingGetGeneratedContent = false;
            state.generatedContent = { ...state.generatedContent, [`${action?.payload?.data?.moduleId}|${action?.payload?.data?.schemaKey}`]: action?.payload?.data };
            state.error = false;
        },
        [getGeneratedContent.rejected]: (state, action) => {
            state.isLoadingGetGeneratedContent = false;
            state.error = true;
        },
        [stopGeneration.pending]: (state, action) => {
            state.isLoadingStopGeneration = true;
            state.error = false;
        },
        [stopGeneration.fulfilled]: (state, action) => {
            state.isLoadingStopGeneration = false;
            state.generatedContent = { ...state.generatedContent, [`${action?.payload?.data?.moduleId}|${action?.payload?.data?.schemaKey}`]: action?.payload?.data };
            state.error = false;
        },
        [stopGeneration.rejected]: (state, action) => {
            state.isLoadingStopGeneration = false;
            state.error = true;
        },//generateTagSummary
        [generateTagSummary.pending]: (state, action) => {
            state.error = false;
        },
        [generateTagSummary.fulfilled]: (state, action) => {
            state.tagSummary = action?.payload?.data
            state.error = false;
        },
        [generateTagSummary.rejected]: (state, action) => {
            state.error = true;
        },//getGeneratedTagSummary
        [getGeneratedTagSummary.pending]: (state, action) => {
            state.error = false;
        },
        [getGeneratedTagSummary.fulfilled]: (state, action) => {
            state.tagSummary = action?.payload?.data
            state.error = false;
        },
        [getGeneratedTagSummary.rejected]: (state, action) => {
            state.error = true;
        },
        [stopTagSummaryGeneration.pending]: (state, action) => {
            state.error = false;
        },
        [stopTagSummaryGeneration.fulfilled]: (state, action) => {
            state.tagSummary = action?.payload?.data
            state.error = false;
        },
        [stopTagSummaryGeneration.rejected]: (state, action) => {
            state.error = true;
        },
        [logoutUser.fulfilled]: (state) => {
            return initialState;
        },
        [logoutUser.rejected]: (state) => {
            return initialState;
        },
    },
});

export const getError = (state) => state.ai.error;
export const getIsLoadingGenerateContent = (state) => state.ai.isLoadingGenerateContent;
export const getIsLoadingGetGeneratedContent = (state) => state.ai.isLoadingGetGeneratedContent;
export const getGeneratedContentObject = (state) => state.ai.generatedContent;
export const getIsLoadingStopGeneration = (state) => state.ai.isLoadingStopGeneration;
export const getTagSummaryContent = (state) => state.ai.tagSummary

export default aiSlice;
